import React from 'react';

export default function Privacy() {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="bg-slate-900 py-16">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <p className="text-white/60 font-medium mb-4 tracking-wide text-sm uppercase">Legal</p>
          <h1 className="text-4xl lg:text-5xl font-light text-white mb-4 leading-tight">
            Privacy
            <span className="block font-semibold">Policy</span>
          </h1>
          <p className="text-slate-400 max-w-3xl mx-auto">
            Your privacy is important to us. Learn how we collect, use, and protect your information.
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4">
          <div className="prose prose-slate max-w-none">
            <p className="text-slate-500 mb-8">Last updated: December 2025</p>

            <h2 className="text-2xl font-bold text-slate-800 mb-4">1. Information We Collect</h2>
            <p className="text-slate-600 leading-relaxed mb-4">
              We collect information that you provide directly to us, including:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-6 space-y-2">
              <li>Name, email address, phone number, and mailing address</li>
              <li>Property information and service history</li>
              <li>Payment information (processed securely through our payment providers)</li>
              <li>Communication preferences and service feedback</li>
              <li>Information from your use of our website (cookies, IP address, browser type)</li>
            </ul>

            <h2 className="text-2xl font-bold text-slate-800 mb-4">2. How We Use Your Information</h2>
            <p className="text-slate-600 leading-relaxed mb-4">
              We use the information we collect to:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-6 space-y-2">
              <li>Provide, maintain, and improve our drainage services</li>
              <li>Process your service requests and payments</li>
              <li>Send you service updates, confirmations, and technical notices</li>
              <li>Respond to your comments, questions, and customer service requests</li>
              <li>Send you marketing communications (with your consent)</li>
              <li>Monitor and analyze trends, usage, and activities</li>
              <li>Comply with legal obligations</li>
            </ul>

            <h2 className="text-2xl font-bold text-slate-800 mb-4">3. Information Sharing</h2>
            <p className="text-slate-600 leading-relaxed mb-6">
              We do not sell your personal information. We may share your information with:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-6 space-y-2">
              <li>Service providers who assist us in operating our business</li>
              <li>Professional advisors such as lawyers and accountants</li>
              <li>Law enforcement or regulatory agencies when required by law</li>
              <li>Third parties in connection with a merger, acquisition, or sale of assets</li>
            </ul>

            <h2 className="text-2xl font-bold text-slate-800 mb-4">4. Data Security</h2>
            <p className="text-slate-600 leading-relaxed mb-6">
              We implement appropriate technical and organizational measures to protect your personal information 
              against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission 
              over the internet or electronic storage is 100% secure.
            </p>

            <h2 className="text-2xl font-bold text-slate-800 mb-4">5. Cookies and Tracking</h2>
            <p className="text-slate-600 leading-relaxed mb-6">
              We use cookies and similar tracking technologies to collect information about your browsing activities. 
              You can control cookies through your browser settings. However, disabling cookies may affect your 
              ability to use certain features of our website.
            </p>

            <h2 className="text-2xl font-bold text-slate-800 mb-4">6. Your Rights</h2>
            <p className="text-slate-600 leading-relaxed mb-4">
              You have the right to:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-6 space-y-2">
              <li>Access, update, or delete your personal information</li>
              <li>Object to or restrict the processing of your information</li>
              <li>Withdraw consent for marketing communications</li>
              <li>Request a copy of your data in a portable format</li>
              <li>Lodge a complaint with a supervisory authority</li>
            </ul>

            <h2 className="text-2xl font-bold text-slate-800 mb-4">7. Data Retention</h2>
            <p className="text-slate-600 leading-relaxed mb-6">
              We retain your personal information for as long as necessary to fulfill the purposes outlined in this 
              policy, unless a longer retention period is required by law or for legitimate business purposes.
            </p>

            <h2 className="text-2xl font-bold text-slate-800 mb-4">8. Children's Privacy</h2>
            <p className="text-slate-600 leading-relaxed mb-6">
              Our services are not directed to children under 16. We do not knowingly collect personal information 
              from children under 16. If you become aware that a child has provided us with personal information, 
              please contact us.
            </p>

            <h2 className="text-2xl font-bold text-slate-800 mb-4">9. Changes to This Policy</h2>
            <p className="text-slate-600 leading-relaxed mb-6">
              We may update this Privacy Policy from time to time. We will notify you of any changes by posting the 
              new policy on this page and updating the "Last updated" date.
            </p>

            <h2 className="text-2xl font-bold text-slate-800 mb-4">10. Contact Us</h2>
            <p className="text-slate-600 leading-relaxed mb-4">
              If you have any questions about this Privacy Policy or our data practices, please contact us:
            </p>
            <ul className="list-none text-slate-600 space-y-2 mb-6">
              <li>Phone: (234) 231 - 2123</li>
              <li>Email: contact@perfectpandarepairs.com</li>
              <li>Address: 1440 70th St, City, State 12345</li>
            </ul>
          </div>
        </div>
      </section>

    </div>
  );
}